import { useEffect } from 'react';
import './App.css';
import './styles/index.css';
import { Switch, Route, useLocation, useHistory } from 'react-router-dom';
import { routes } from './routes';
import { usePageTrackingGA, useWebgate } from '@xvia/webgate-connect';
import { NavigationProvider } from './contexts/NavigationContext';
import { useAccessibilitySettings } from './hooks/useAccessibilitySettings';

function App() {
  const location = useLocation();
  const history = useHistory();
  const { accessToken, portalConnect } = useWebgate();

  usePageTrackingGA(location);
  useAccessibilitySettings();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.detail?.pushRoute) {
        history.push(event.data.detail.pushRoute);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [history]);

  useEffect(() => {
    const currentRoute = routes.find(route => route.path === location.pathname);
    
    if (currentRoute?.private && !accessToken && portalConnect) {
      portalConnect.login().then(() => {
        portalConnect.redirectTo('/app/catalog/dashboard');
      });
    }
  }, [location.pathname, portalConnect, accessToken]);

  return (
    <NavigationProvider>
      <Switch>
        {routes.map(({ component: RouteComponent, path, exact }) => (
          <Route key={path} path={path} exact={exact}>
            <RouteComponent />
          </Route>
        ))}
      </Switch>
    </NavigationProvider>
  );
}

export default App;
